module.exports = __webpack_public_path__ + "static/img/radio_blank.c6e13f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lite/icon/radio_blank.svg
// module id = m6kV
// module chunks = 2